import { createSelector } from 'reselect';
import { getLatestActivityBase } from './getLatestActivityBase';
import { getHasOpenActivitySet } from './getHasOpenActivitySet';
import { getActivityTypes } from './getActivityTypes';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

export const getIsPausedSetup = createSelector(
  [
    getLatestActivityBase,
    getHasOpenActivitySet,
    getActivityTypes,
    getCurrentLaborTicket,
    getPostLaborUpdatesOnNats,
  ],
  (
    latestActivity,
    hasOpenActivitySet,
    activityTypes,
    currentLaborTicket,
    natsFlowEnabled
  ) => {
    // NATS flow: check labor ticket's customFields.endBehavior and type
    if (natsFlowEnabled) {
      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      const isSetup = currentLaborTicket?.type?.toLowerCase() === 'setup';
      return endBehavior === 'keep-open' && isSetup;
    }

    // Standard flow: check activity state
    // Paused setup: activity is closed but activity set is open
    if (!latestActivity?.end || !hasOpenActivitySet) {
      return false;
    }

    // Check if the activity is a setup activity
    const activityType = activityTypes?.find((at) => {
      return at.activityTypeRef === latestActivity.activityTypeRef;
    });
    return activityType?.activityMode === 'setup';
  }
);
